import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const PublicRoute = ({ children }) => {
  const user_id = useSelector((state) => state.auth.user_id);

  if (user_id) {
    return <Navigate to="/" />;
  }

  return children;
};

export default PublicRoute;
